import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PostalAddress } from '../../../common/model/postal-address';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { MessageService } from '../../../core/service/message.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { Mail } from '../../model/mail';
import { MailService } from '../../service/data/mail.service';
import { LetterFormComponentBase } from '../base/letter-form.base';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';

@Component({
    selector: 'app-letter-form-component',
    templateUrl: './letter-form-component.component.html',
    styleUrls: ['./letter-form-component.component.scss'],
    providers: [DeleteFormCommandHandler, FormCommandHandlerResolver, { provide: DataService, useExisting: MailService }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LetterFormComponent extends LetterFormComponentBase {
  constructor(
    private _nativeWindow: NativeWindowService,
    activatedRoute: ActivatedRoute,
    commandDispatcher: CommandDispatcher,
    handlerResolver: FormCommandHandlerResolver,
    fb: FormBuilder,
    cf: FormControlExFactory,
    service: MailService,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, fb, cf, service, commandDispatcher, handlerResolver, messageService, navigation);
  }

  private _send: boolean;
  get canSend(): boolean {
    return this.form && this.form.valid && !this._send;
  }

  get isPreviewDisabled(): boolean {
    return !this.form || this.form.invalid || this.form.disabled;
  }

  get isSendDisabled(): boolean {
    return !this.canSend || this.form?.disabled;
  }

  recipientAddress: PostalAddress;

  protected formSubmitted() {
    if (this._send) {
      this.service.send(this.dataContext.id).subscribe(
        () => {
          this._send = false;
          super.formSubmitted();
        },
        error => this.messageService.showError(error)
      );
    } else {
      super.formSubmitted();
    }
  }

  protected getFormGroup(): FormGroup {
    let group = super.getFormGroup();
    group.addControl('recipientAddress', this.fb.group({}));
    return group;
  }

  protected init(letter: Mail) {
    super.init(letter);
    this.recipientAddress = this.dataContext.recipientAddress;
  }

  preview() {
    let serviceResult: Observable<Blob>;
    if (this.isNew) {
      serviceResult = this.service.previewNew(this.form.value);
    } else {
      serviceResult = this.service.preview(this.dataContext.id);
    }
    this.AddSubscription(serviceResult.subscribe(res => this._nativeWindow.openFile(res)));
  }

  send() {
    if (this.form.invalid) return;

    if (!this.form.pristine && !this.isNew) {
      this._send = true;
      this.onSubmit();
    } else if (this.dataContext.id) {
      this.service.send(this.dataContext.id).subscribe(
        () => this.formSubmitted(),
        error => this.messageService.showError(error)
      );
    } else {
      this.service.sendNew(this.form.value).subscribe(
        () => this.formSubmitted(),
        error => this.messageService.showError(error)
      );
    }
  }
}
